<div class="loading-modal-spinner">
    <owc-progress-spinner #progressSpinnerElement [size]="'xxLarge'" [value]="50" />
</div>